import {
  SEARCH_SAP_GET_DATA,
  STORE_CALL_VISIT_POST,
  STORE_CALL_VISIT_GET,
  STORE_CALL_VISIT_SEND_MAIL_POST,
  STORE_CALL_VISIT_GET_VENDOR_DATA,
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  searchsap: {},
  storeschedule: {},
  success: false,
  storevisits: [],
  storevisitsLoading: false,
  storevisitsError: null,
  sendmail: [],
  vendordata: [],
  vendordataLoading: false,
  vendordataError: null,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {

    // ── GET SEARCH SAP ──────────────────────────────────────
    case SEARCH_SAP_GET_DATA.SEARCH_SAP_GET_DATA_LOAD:
      return { ...state, loading: true, searchsap: {}, error: null };
    case SEARCH_SAP_GET_DATA.SEARCH_SAP_GET_DATA_SUCCESS:
      return { ...state, loading: false, searchsap: action.searchsap, error: null };
    case SEARCH_SAP_GET_DATA.SEARCH_SAP_GET_DATA_FAIL:
      return { ...state, loading: false, searchsap: {}, error: action.error };

    // ── POST STORE VISIT ────────────────────────────────────
    case STORE_CALL_VISIT_POST.STORE_CALL_VISIT_POST_LOAD:
      return { ...state, loading: true, error: null, success: false };
    case STORE_CALL_VISIT_POST.STORE_CALL_VISIT_POST_SUCCESS:
      return { ...state, loading: false, success: true, storeschedule: action.data, error: null };
    case STORE_CALL_VISIT_POST.STORE_CALL_VISIT_POST_FAIL:
      return { ...state, loading: false, success: false, error: action.error };

    // ── GET STORE VISIT LIST ────────────────────────────────
    case STORE_CALL_VISIT_GET.STORE_CALL_VISIT_GET_LOAD:
      return { ...state, storevisitsLoading: true, storevisits: [], storevisitsError: null };
    case STORE_CALL_VISIT_GET.STORE_CALL_VISIT_GET_SUCCESS:
      return { ...state, storevisitsLoading: false, storevisits: action.storevisits, storevisitsError: null };
    case STORE_CALL_VISIT_GET.STORE_CALL_VISIT_GET_FAIL:
      return { ...state, storevisitsLoading: false, storevisits: [], storevisitsError: action.error };

    // ── POST SEND MAIL ────────────────────────────────────
    case STORE_CALL_VISIT_SEND_MAIL_POST.STORE_CALL_VISIT_SEND_MAIL_POST_LOAD:
      return { ...state, loading: true, error: null, success: false };
    case STORE_CALL_VISIT_SEND_MAIL_POST.STORE_CALL_VISIT_SEND_MAIL_POST_SUCCESS:
      return { ...state, loading: false, success: true, sendmail: action.data, error: null };
    case STORE_CALL_VISIT_SEND_MAIL_POST.STORE_CALL_VISIT_SEND_MAIL_POST_FAIL:
      return { ...state, loading: false, success: false, error: action.error };  

    case STORE_CALL_VISIT_GET_VENDOR_DATA.STORE_CALL_VISIT_GET_VENDOR_DATA_LOAD:
      return { ...state, vendordataLoading: true, vendordata: [], vendordataError: null };
    case STORE_CALL_VISIT_GET_VENDOR_DATA.STORE_CALL_VISIT_GET_VENDOR_DATA_SUCCESS:
      return { ...state, vendordataLoading: false, vendordata: action.vendordata, vendordataError: null };
    case STORE_CALL_VISIT_GET_VENDOR_DATA.STORE_CALL_VISIT_GET_VENDOR_DATA_FAIL:
      return { ...state, vendordataLoading: false, vendordata: [], vendordataError: action.error };

    default:
      return { ...state };
  }
};

export default Reducer;